export default "__VITE_ASSET__DgMI8liD__"